import type { ReactNode } from "react";
import { create } from "zustand";

export type BannerNotificationType = "warning" | "error" | "info" | "success";

export interface BannerNotification {
  id: string;
  type: BannerNotificationType;
  message: ReactNode;
  dismissible?: boolean;
  onDismiss?: () => void;
}

interface BannerNotificationStore {
  notifications: BannerNotification[];
  add: (notification: BannerNotification) => void;
  dismiss: (id: string) => void;
  dismissAll: () => void;
}

export const useBannerNotificationStore = create<BannerNotificationStore>((set) => ({
  notifications: [],
  add: (notification) =>
    set((state) => {
      const exists = state.notifications.some((n) => n.id === notification.id);
      if (exists) {
        return {
          notifications: state.notifications.map((n) =>
            n.id === notification.id ? notification : n
          ),
        };
      }
      return { notifications: [...state.notifications, notification] };
    }),
  dismiss: (id) =>
    set((state) => ({ notifications: state.notifications.filter((n) => n.id !== id) })),
  dismissAll: () => set({ notifications: [] }),
}));
